import { editIcon } from '@/images'
import { GxIcon } from '@garpix/garpix-web-components-react'
import classNames from 'classnames'
import React from 'react'
import style from './styles/upload_avatar.module.scss'

const UploadAvatar = ({
  className = '',
  onChange,
  disabled = false
}): React.ReactElement => {
  return (
    <label
      className={classNames({
        [style.upload__button]: true,
        [className]: Boolean(className)
      })}
    >
      <input
        disabled={disabled}
        className='hidden'
        type='file'
        name='avatar'
        onChange={onChange}
      />
      <span>
        <GxIcon src={editIcon} className={style.upload__icon} />
      </span>
    </label>
  )
}

export default UploadAvatar
